exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-menu[data-v-60999538]{margin-bottom:0.4rem}.page-menu .page-menu-main[data-v-60999538]{padding:0.06rem 0.12rem;border-radius:0.06rem;border:1px solid #225bfc;font-family:HurmeGeometricSans2-Bold, HurmeGeometricSans2}.page-menu[data-v-60999538] .el-radio-button--medium .el-radio-button__inner{font-size:0.2rem;color:#ffffff;padding:0.1rem 0.4rem;border-radius:0.06rem;border:none;background-color:transparent}.page-menu[data-v-60999538] .el-radio-button__orig-radio:checked+.el-radio-button__inner{color:#ffffff;font-weight:500;background:#225bfc;box-shadow:none}\n", ""]);

// exports
